module.exports = __webpack_public_path__ + "img/login-logo.26bdd3f9.jpg";